function overlay() {
  const onBodyClickCloseOverlay = e => {
    let target = e.target;
    if (target.classList.contains('js-overlay'))
      target.classList.remove('overlay--show');
  };

  const onOverlayBtnClick = e => {
    const targetOverlayId = e.currentTarget.dataset.overlaytarget;
    const overlay = document.getElementById(targetOverlayId);
    overlay.classList.add('overlay--show');
  };

  const init = () => {
    const overlay = document.querySelector('.js-overlay');
    if (overlay) {
      document.body.addEventListener('click', onBodyClickCloseOverlay);

      const overlayBtns = [...document.querySelectorAll('.js-overlay-btn')];
      overlayBtns.forEach(btn => {
        btn.addEventListener('click', onOverlayBtnClick);
      });
    }
  };

  init();
}
export default overlay;
